/**
 * TEXTOS DO FECHAMENTO DA PRÉ-VENDA (CERES-PRE-004 a 006) — português.
 *
 * Em módulo próprio, como os da CERES-UX-001: espalhados em `PT` (i18n.ts) e,
 * em inglês, em `EN` (i18n.en.ts, a partir de `i18n.pv.en.ts`). O tipo obriga
 * a paridade, e o teste de idioma a confere de novo no dicionário final.
 */

export const PV_PT = {
  // ---- PRE-004: o quadro da decisão e os requisitos -----------------------
  'pv.req.paraConfirmarFalta': 'Para confirmar, falta:',
  'pv.req.decisaoRegistrada': 'Decisão',
  'pv.req.semDecisao': 'Ainda não escolhida',
  'pv.req.destino': 'Resultado',
  'pv.req.tudoPronto': 'Tudo preenchido para confirmar',
  'pv.req.obrigatorios': 'Ainda falta preencher',
  'pv.req.tambemParaAvancar': 'Para avançar, também é preciso (em outro formulário)',
  'pv.req.permaneceEm': 'Permanece em',
  'pv.req.naoInformado': 'Não informado',
  'pv.req.pergunta': 'Pergunta',

  'pv.req.aderenciaSim': 'Aderência "Sim"',
  'pv.req.justificativa': 'Justificativa',
  'pv.req.responsavel': 'Responsável',
  'pv.req.segmento': 'Segmento',
  'pv.req.exigeSegmento':
    'Informe o segmento ou perfil: é exigência para a pré-venda entrar no próximo estado.',
  'pv.req.motivoDaNutricao': 'Motivo da nutrição',
  'pv.req.dataDeRetomada': 'Data de retomada (a partir de amanhã)',
  'pv.req.motivoDoDescarte': 'Motivo do descarte',
  'pv.req.observacaoDoMotivo': 'Observação (o motivo exige)',
  'pv.req.exigeDataFutura': 'Escolha uma data a partir de amanhã.',

  'pv.req.avaliar.permanece':
    'Sem decisão de aderência, ou com "Ainda não tenho informações suficientes", a pré-venda continua em',
  'pv.req.avaliar.aprovar': 'Aprovar: a empresa é classificada como prospect e passa para',
  'pv.req.avaliar.nutrir':
    'Enviar para nutrição: sai da fila até a data de retomada e volta ao mesmo estado nessa data.',
  'pv.req.avaliar.descartar':
    'Descartar: encerra esta pré-venda com o motivo; o histórico fica e ela pode ser reativada.',
  'pv.req.avaliar.parcial':
    'Ainda não tenho informações suficientes: salva o que já se sabe e a pré-venda continua em',
  'pv.req.emNutricao': 'Em nutrição até a data de retomada',
  'pv.req.emNutricaoVoltaEm': 'Em nutrição — volta à fila em',
  'pv.req.encerradaDescartada': 'Encerrada · descartada (sai da operação)',

  'pv.req.assunto': 'Assunto',
  'pv.req.desfecho': 'Desfecho',
  'pv.req.proximaAcao': 'Próxima ação',
  'pv.req.dataDaProximaAcao': 'Data da próxima ação',
  'pv.req.exigeAssunto': 'Descreva em poucas palavras o que foi feito.',
  'pv.req.exigeDesfecho': 'Escolha o que aconteceu: conversa ou tentativa.',
  'pv.req.exigeProximaAcao':
    'Diga qual é o próximo passo: a pré-venda continua aberta depois deste registro.',
  'pv.req.exigeDataDeHoje': 'Escolha a data da próxima ação (hoje ou depois).',
  'pv.req.exemploProximaAcao': 'Ex.: ligar de novo para o diretor de operações',
  'pv.req.contato.conversa': 'Conversa — conta como interesse',
  'pv.req.contato.tentativa': 'Tentativa — não conta como interesse',
  'pv.req.contato.naoMudaEstado':
    'Neste estado, registrar contato não muda o estado: a decisão dele tem formulário próprio.',
  'pv.req.contato.grupoConversa': 'Conversa (conta como interesse)',
  'pv.req.contato.grupoTentativa': 'Tentativa (não conta como interesse)',
  'pv.req.contato.contaComoInteresse': 'Conta como interesse:',
  'pv.req.contato.contaComoInteresseTexto':
    'atendeu e conversou, respondeu, aceitou reunião, pediu retorno ou reunião realizada.',
  'pv.req.contato.naoConta': 'Não conta:',
  'pv.req.contato.naoContaTexto':
    'não atendeu, sem resposta e e-mail enviado — ficam registrados como tentativa.',

  'pv.req.qual.resultado.APROVADO': 'Qualificação aprovada',
  'pv.req.qual.resultado.REPROVADO': 'Qualificação não aprovada',
  'pv.req.qual.resultado.INCOMPLETO': 'Qualificação incompleta',
  'pv.req.qual.permanece':
    'Pergunta sem resposta fica em aberto — nunca vale como "não". Com obrigatória em aberto ou respondida "não", a pré-venda continua no estado atual.',
  'pv.req.qual.situacao.EM_ABERTO': 'Não respondida',
  'pv.req.qual.situacao.SEM_EVIDENCIA': 'Respondida sem evidência',
  'pv.req.qual.situacao.COM_EVIDENCIA': 'Respondida com evidência',
  'pv.req.qual.situacao.NAO_APROVADA': 'Não aprovada',

  'pv.req.entrega.escolha': 'Vincular a um negócio aberto ou criar um novo',
  'pv.req.entrega.titulo': 'Nome da oportunidade',
  'pv.req.entrega.pipeline': 'Pipeline comercial',
  'pv.req.entrega.criar': 'Criar oportunidade nova',
  'pv.req.entrega.vincular': 'Vincular a negócio aberto',
  'pv.req.entrega.permanece':
    'A pré-venda só é marcada como entregue depois de a oportunidade ser criada ou vinculada. Se algo falhar, ela continua aqui para nova tentativa.',
  'pv.req.entrega.empresa': 'Empresa',
  'pv.req.entrega.contato': 'Contato principal',
  'pv.req.entrega.necessidade': 'Necessidade',
  'pv.req.entrega.evidencias': 'Evidências (qualificação)',
  'pv.req.entrega.servico': 'Serviço ou oferta',
  'pv.req.entrega.responsavel': 'Responsável',

  'pv.req.descarte.confirmar': 'Descartar pré-venda',
  'pv.req.descarte.efeito':
    'Ao confirmar, a pré-venda sai da operação e passa a aparecer em Encerradas, com o motivo. A empresa continua no CRM, o histórico fica e a pré-venda pode ser reativada.',
  'pv.req.nutrir.volta': 'O estado não muda: na data de retomada a pré-venda volta à fila em',
  'pv.req.nutrir.comResponsavel': 'com o responsável',

  'pv.req.servicoDefinido': 'Serviço definido',
  'pv.req.porQueServico':
    'É o que o Comercial vai receber como interesse do cliente. Vem do Catálogo Comercial desta organização.',

  // ---- PRE-005: ICP, entrada, listas e origens ----------------------------
  'pv.icp.titulo': 'Perfil de cliente ideal',
  'pv.icp.semPerfil':
    'Nenhum perfil de cliente ideal publicado. A avaliação é manual: registre a decisão e a justificativa.',
  'pv.icp.configurar': 'Configurar o perfil de cliente ideal',
  'pv.icp.escolhaServico':
    'Escolha o produto ou serviço para ver o perfil dele. Com perfil publicado:',
  'pv.icp.servicoSemPerfil': 'O serviço escolhido não tem perfil publicado: a avaliação é manual.',
  'pv.icp.semAvaliacao': 'Esta empresa ainda não foi avaliada por este perfil.',
  'pv.icp.avaliar': 'Avaliar pelo perfil',
  'pv.icp.orienta':
    'O perfil orienta; a decisão final e a justificativa são de quem avalia. Critério sem dado não conta como zero.',

  'pv.origem.LISTA': 'Lista',
  'pv.origem.IMPORTACAO': 'Importação',
  'pv.origem.MIGRACAO_SDR': 'Migração do módulo anterior',
  'pv.origem.WHATSAPP': 'WhatsApp',
  'pv.origem.ASSISTENTE': 'Assistente',
  'pv.origem.INTELIGENCIA_COMERCIAL': 'Inteligência Comercial',
  'pv.origem.VERIFICACAO': 'Verificação interna',
  'pv.origem.EVENTO': 'Evento ou feira',
  'pv.origem.INDICACAO': 'Indicação',
  'pv.origem.PROSPECCAO_ATIVA': 'Prospecção ativa',
  'pv.origem.INBOUND': 'Contato recebido',
  'pv.origem.SITE': 'Site',
  'pv.origem.PARCEIRO': 'Parceiro',
  'pv.origem.MANUAL': 'Cadastro manual',
  'pv.origem.outra': 'Outra origem',
  'pv.origem.qual': 'Qual origem?',

  // ---- PRE-005: entrada em volume e listas -----------------------------
  'pv.lista.preVendas': 'pré-vendas',
  'pv.imp.situacao.NOVA': 'Pronta · nova empresa',
  'pv.imp.situacao.EMPRESA_EXISTENTE': 'Pronta · empresa já cadastrada',
  'pv.imp.situacao.POSSIVEL_DUPLICIDADE': 'Possível duplicidade',
  'pv.imp.situacao.JA_NA_LISTA': 'Já pertence à lista',
  'pv.imp.situacao.JA_EM_PRE_VENDA': 'Já possui pré-venda equivalente',
  'pv.imp.situacao.INVALIDA': 'Inválida',
  'pv.imp.exigeLista': 'Escolha a lista de destino ou crie uma nova antes de conferir.',
  'pv.imp.criadas': 'pré-venda(s) criada(s)',
  'pv.imp.ignoradas': 'deixada(s) de fora',
  'pv.imp.falhas': 'falha(s)',
  'pv.imp.req.lista': 'Lista de destino',
  'pv.imp.req.linhas': 'Linhas da planilha (até 1.000)',
  'pv.imp.req.previa': 'Conferir a prévia',
  'pv.imp.req.decisoes': 'Decidir cada possível duplicidade',
  'pv.imp.req.incluir': 'Ao menos uma linha a incluir',
  'pv.imp.formatos': 'Colar, CSV ou planilha salva como CSV',
  'pv.imp.comoColar':
    'Cole as linhas da planilha (uma empresa por linha) ou escolha um arquivo CSV. Com cabeçalho (nome, CNPJ, site, segmento, cidade, UF), as colunas são lidas pelo nome; sem cabeçalho, a ordem é nome; CNPJ; site. Planilha do Excel: salve como CSV.',
  'pv.imp.arquivo': 'Arquivo CSV',
  'pv.imp.exemplo': 'Metalúrgica Vale Verde; 11.222.333/0001-81; valeverde.com.br',
  'pv.imp.linhasLidas': 'linha(s) lida(s)',
  'pv.imp.maximo': 'envie no máximo 1.000 linhas por vez',
  'pv.imp.objetivo': 'Objetivo ou serviço deste lote (opcional)',
  'pv.imp.objetivoExemplo': 'Ex.: automação de testes para indústria',
  'pv.imp.prontas': 'pronta(s) para inclusão',
  'pv.imp.duvidosas': 'possível(is) duplicidade(s)',
  'pv.imp.semDecisao': 'sem decisão',
  'pv.imp.deFora': 'fora da importação',
  'pv.imp.decisao': 'Decisão',
  'pv.imp.decidir': 'Decidir…',
  'pv.imp.usar': 'Usar',
  'pv.imp.outraEmpresa': 'É outra empresa — cadastrar',
  'pv.imp.deixarDeFora': 'Deixar de fora',
  'pv.imp.seraIncluida': 'Será incluída',
  'pv.imp.ficaDeFora': 'Fica de fora',
  'pv.imp.algumasFalharam': 'Algumas linhas não entraram:',
  'pv.imp.escolhaLista': 'Escolha a lista',
  'pv.imp.nomeRepetido':
    'Já existe uma lista ativa com este nome: escolha-a acima ou use outro nome.',

  // ---- PRE-006: Resultados ----
  'pv.res.todos': 'Todos',
  'pv.res.menosDeUmDia': 'menos de 1 dia',
  'pv.res.lista': 'Lista',
  'pv.res.servico': 'Serviço ou oferta',
  'pv.res.ultimos': 'Últimos',
  'pv.res.periodoDe': 'Período de',
  'pv.res.a': 'a',
  'pv.res.semFiltros': 'Sem filtros: todas as pré-vendas que você acompanha.',
  'pv.res.filtrosAtivos': 'Filtros aplicados a todos os blocos:',
  'pv.res.operacao': 'Operação agora',
  'pv.res.operacaoAjuda':
    'O que está aberto hoje — as mesmas contagens da Carteira. Não depende do período.',
  'pv.res.preVendasEmAndamento': 'pré-vendas em andamento',
  'pv.res.emNutricaoFutura': 'em nutrição com retomada futura',
  'pv.res.estado': 'Estado',
  'pv.res.abertas': 'Abertas',
  'pv.res.haQuanto': 'No estado há (mediana)',
  'pv.res.maisAntiga': 'Mais antiga',
  'pv.res.semDadosSuficientes': 'Sem dados suficientes',
  'pv.res.historico': 'Histórico do período',
  'pv.res.historicoAjuda':
    'O que aconteceu entre as duas datas. Uma empresa pode ter mais de uma pré-venda.',
  'pv.res.iniciadas': 'Pré-vendas iniciadas',
  'pv.res.empresasUnicas': 'Empresas distintas nessas pré-vendas',
  'pv.res.leads': 'Chegaram a "Em qualificação"',
  'pv.res.qualificadas': 'Ficaram prontas para o Comercial',
  'pv.res.oportunidades': 'Oportunidades geradas',
  'pv.res.descartadas': 'Pré-vendas descartadas',
  'pv.res.reativacoes': 'Reativações',
  'pv.res.atividades': 'Atividades realizadas',
  'pv.res.conversaoAjuda':
    'Das pré-vendas que chegaram ao estado de origem no período, quantas avançaram ao seguinte (até hoje).',
  'pv.res.transicao': 'De → para',
  'pv.res.chegaram': 'Chegaram',
  'pv.res.avancaram': 'Avançaram',
  'pv.res.tempoAjuda':
    'Permanências que terminaram no período (mediana). Para o que ainda está aberto, veja "Operação agora".',
  'pv.res.mediana': 'Mediana',
  'pv.res.amostra': 'Amostra',
  'pv.res.descarteAjuda': 'Pré-vendas descartadas no período, por motivo. Total:',
  'pv.res.semDescartes': 'Nenhum descarte no período.',
  'pv.res.quantidade': 'Quantidade',
  'pv.res.recorteAjuda': 'Pré-vendas iniciadas no período e o que aconteceu com elas até hoje.',
  'pv.res.semIniciadas': 'Nenhuma pré-venda iniciada no período com estes filtros.',
  'pv.res.colPreVendas': 'Pré-vendas',
  'pv.res.colEmpresas': 'Empresas',
  'pv.res.colQualificadas': 'Qualificadas',
  'pv.res.colOportunidades': 'Oportunidades',
} as const;
